import React, {useState, useEffect, useMemo} from 'react';
import { useQuery } from '@tanstack/react-query';
import Select, {customStyles, DropdownIndicator, SMETheme} from '../Select.jsx';
import {fetchJson} from '../../../helpers/fetch.js';

import {
  common_user_organisation_tree_options_path,
} from '~/routes'

function UserTreeSelect({
  name,
  value: propsValue,
  label: propsLabel,
  placeholder,
  onChange = () => {},
  isDisabled = false,
  isClearable = false,
  readOnly = false,
  excludeUserTypes = [],
  additionalOptions = [],
  truncateOptions = false,
  ...rest
}) {
  const [value, setValue] = useState({value: propsValue, label: propsLabel});
  const { data = (value ? [{ value: propsValue, label: propsLabel }] : []), isLoading } = useQuery({
    queryKey: ['commonUserOrganisationTreeOptions'],
    queryFn: () => fetchJson(common_user_organisation_tree_options_path({exclude_user_types: excludeUserTypes})),
    enabled: !isDisabled && !readOnly,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    setValue({value: propsValue, label: propsLabel});
  }, [propsValue, propsLabel]);

  const handleChange = (v) => {
    setValue(v);
    onChange(v);
  }

  const buildOptions = (items, parentId = null, level = 0) => {
    if(items.length === 1) {
      return [{...items[0], is_user: true}];
    }
    return items
      .filter((item) => item.parent_id === parentId)
      .flatMap(({id, name, is_user, is_leaf}) => {
        return [
          {
            value: id,
            label: name,
            disabled: !is_user,
            is_user,
            is_leaf,
            level,
          },
          ...buildOptions(items, id, level + 1),
        ];
      });
  }

  const formatOptionLabel = ({label, is_user, is_leaf, level, no_icon = false}, {context}) => {
    const iconClass = is_user ? 'fa fa-user text-muted' : is_leaf ? 'fa fa-caret-down' : 'fa fa-caret-down';
    return (
      <span className={truncateOptions ? 'text-truncate' : ''} style={context === 'menu' ? {paddingLeft: level * 15} : {}}>
        {!no_icon && <i className={iconClass}/>} {label}
      </span>
    )
  }

  const options = useMemo(() => {
    return [
      ...additionalOptions,
      ...buildOptions(data),
    ];
  }, [data, additionalOptions]);

  return (
    <Select
      isLoading={isLoading}
      name={name}
      value={value?.value}
      options={options}
      formatOptionLabel={formatOptionLabel}
      placeholder={placeholder}
      onChange={handleChange}
      className={`react-select-bootstrap ${isDisabled && "disabled"}  ${readOnly && "readonly"}`}
      styles={customStyles}
      components={{DropdownIndicator: DropdownIndicator}}
      theme={SMETheme}
      isDisabled={isDisabled || readOnly}
      isClearable={isClearable}
      returnOptionObject={true}
      {...rest}
    />
  )
}

export default UserTreeSelect;
